import { Link } from "react-router-dom";

export default function IntroSection() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-bold text-primary-700">
              <i className="ri-store-2-line" />
              关于美味的快递
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
              让美味与心意，都以最快的速度抵达
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              自 2019 年从一间 30 平米的小厨房出发，「美味的快递」始终相信好吃的食物值得被认真对待。我们严选持证商家、把控食材来源，也自建同城配送网络，用冷链保温箱把刚出锅的温度送到你手上。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {[
                { icon: "ri-award-line", title: "严选商家", desc: "800+ 家持证餐厅" },
                { icon: "ri-truck-line", title: "自建配送", desc: "120+ 覆盖片区" },
                { icon: "ri-heart-3-line", title: "用心服务", desc: "7×24 小时客服" },
                { icon: "ri-leaf-line", title: "品质承诺", desc: "不新鲜包退" },
              ].map((item) => (
                <div key={item.title} className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-bold text-foreground-950">{item.title}</span>
                    <span className="block text-xs text-foreground-500">{item.desc}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="h-[300px] w-full overflow-hidden rounded-lg md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20clean%20warm%20restaurant%20kitchen%20with%20chef%20preparing%20fresh%20dishes%2C%20steam%20and%20warm%20golden%20light%2C%20amber%20and%20orange%20tones%2C%20editorial%20documentary%20photography%2C%20inviting%20and%20professional%2C%20high%20detail&width=1000&height=1200&seq=home-intro-kitchen&orientation=portrait"
                alt="美味的快递严选商家后厨"
                title="美味的快递 - 严选商家与品质把控"
                className="h-full w-full object-top"
              />
            </div>
            <div className="absolute -bottom-5 right-5 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-restaurant-2-line text-2xl" />
              </span>
              <span>
                <span className="block font-heading text-lg font-extrabold text-foreground-950">800+ 家</span>
                <span className="block text-xs text-foreground-500">严选合作商家</span>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-16 overflow-hidden rounded-lg bg-primary-500">
          <div className="flex flex-col items-center gap-6 px-6 py-10 text-center md:px-12 md:py-14">
            <h3 className="font-heading text-2xl font-extrabold text-background-50 md:text-3xl">
              现在就下单，或者把包裹交给我们的骑手
            </h3>
            <p className="max-w-2xl text-sm leading-relaxed text-primary-50 md:text-base">
              无论是一份热腾腾的午餐，还是一件需要即刻送达的包裹，美味的快递都能帮你稳妥、准时地搞定。
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to="/food-category"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3.5 text-sm font-bold text-primary-700 transition hover:bg-background-100"
              >
                <i className="ri-shopping-bag-3-line" />
                立即订餐
              </Link>
              <Link
                to="/courier-send"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/70 px-7 py-3.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
              >
                <i className="ri-send-plane-fill" />
                立即寄件
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}